export enum ReportCohortPeriod {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
}

export enum ReportCohortDataViewType {
  NUMBER = 'number',
  PERCENT = 'percent',
  CURRENCY = 'currency',
}

export enum ReportCohortGgrType {
  TOTAL = 'total',
  CASINO = 'casino',
  SPORTS = 'sports',
}

export enum ReportCohortBasedOn {
  CREATED = 'created',
  EVENT = 'event',
}

export interface LastDeposit {
  id_jogador: number;
  cpf: string;
  nome: string;
  email: string;
  data_ult_deposito: string;
  valor_ultimo_deposito: number;
}
